import { createRootRoute, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { QueryClientProvider } from '@tanstack/react-query'

import { Navigation } from '../components/Navigation'
import { SessionProvider } from '../context/session'
import { SpeciesSearchContextProvider } from '../context/speciesSearch'
import { queryClient } from '../util/queryclient'

const ContextWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <SpeciesSearchContextProvider>
        <SessionProvider>{children}</SessionProvider>
      </SpeciesSearchContextProvider>
    </QueryClientProvider>
  )
}

export const Route = createRootRoute({
  component: () => (
    <>
      <ContextWrapper>
        <div className="flex min-h-screen flex-col bg-teal-50">
          <main>
            <Navigation />
            <div className="container mx-auto px-2">
              <Outlet />
            </div>
          </main>
        </div>
      </ContextWrapper>
      {import.meta.env.DEV && <TanStackRouterDevtools />}
    </>
  ),
})
